let SizeMixins={
    props:{
        LocalKey:{
            type:String,
            default:()=>''
        }
    },
    data(){
        return {
            SizeObj:[],
            checkList:[],
        }
    },
    methods:{
        //婴幼儿 小童 女士服装 男士服装勾选中全选过滤
        SelectAllSizeTab(val,name){
            this.SizeObj=[]
            let changeList=[]
            val.map(x=>{
                if(x==='1'){
                    for(let i in this.DataList){
                        this.DataList[i].UP.map(y=>{
                            if(y.typeId) changeList.push(y)
                        })
                    }
                }
                if(x==='2'){
                    for(let i in this.DataList){
                        this.DataList[i].DOWN.map(y=>{
                            if(y.typeId) changeList.push(y)
                        })
                    }
                }
            })
            if(changeList.length>0){
                changeList.map(item=>{
                    this.StorageSizeData(item,name)
                })
            }else{
                this.SetSelectTypeSize(name)
            }
        },
        SelectAllSizeBoyAndGirl(val,name){
            this.SizeObj=[]
            let changeList=[]
            val.map(x=>{
                if(x==='1'){
                    for(let i in this.DataList){
                        this.DataList[i].UP.map(y=>{
                            if(y.modelExtendCode==='BOY'){
                                if(y.typeId) changeList.push(y)
                            }
                        })
                    }
                }
                if(x==='2'){
                    for(let i in this.DataList){
                        this.DataList[i].UP.map(y=>{
                            if(y.modelExtendCode==='GIRL'){
                                if(y.typeId) changeList.push(y)
                            }
                        })
                    }
                }
                if(x==='3'){
                    for(let i in this.DataList){
                        this.DataList[i].DOWN.map(y=>{
                            if(y.modelExtendCode==='BOY'){
                                if(y.typeId) changeList.push(y)
                            }
                        })
                    }
                }
                if(x==='4'){
                    for(let i in this.DataList){
                        this.DataList[i].DOWN.map(y=>{
                            if(y.modelExtendCode==='GIRL'){
                                if(y.typeId) changeList.push(y)
                            }
                        })
                    }
                }
            })
            if(changeList.length>0){
                changeList.map(item=>{
                    this.StorageSizeData(item,name)
                })
            }else{
                this.SetSelectTypeSize(name)
            }

        },
        //过滤是否选中
        filterSizeActive(x){
            let idIndex = this.SizeObj.findIndex(function (item) {
                if (item.typeId === x.typeId) {
                    return item;
                }
            })
            if(idIndex>=0) return true
        },
        //回显历史选中的号型
        EchoSizeData(name){
            let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
            if(SelectTypeSize&&SelectTypeSize.Size){
                let Size=SelectTypeSize.Size
                for(let i in Size){
                    if(Size[i].name===name){
                        this.SizeObj=Size[i].list
                        this.checkList=Size[i].checkList
                    }
                }
            }
        },
        //去重选择的号型并且存储
        StorageSizeData(x,name){
            let idIndex = this.SizeObj.findIndex(function (item) {
                if (item.typeId === x.typeId) {
                    return item;
                }
            })
            if(idIndex<0){
                this.SizeObj.push(x)
            }else{
                this.SizeObj.splice(idIndex,1)
            }
            this.SetSelectTypeSize(name)
        },
        //过滤数据是否全选
        FilterDataSelect(){
            let list=this.DataList
            let OriginalDataDown=0  //原数据
            let OriginalDataUp=0
            for(let i in list){
                list[i]['DOWN'].forEach(x=>{
                    if(x.typeId){
                        OriginalDataDown++
                    }
                })
                list[i]['UP'].forEach(y=>{
                    if(y.typeId){
                        OriginalDataUp++
                    }
                })
            }
            let localDown=0
            let localUp=0
            this.SizeObj.forEach(val=>{
                if(val.typeMainCode==="DOWN"){
                    localDown++
                }else if(val.typeMainCode==="UP"){
                    localUp++
                }
            })
            this.checkList=[]

            if(OriginalDataUp===localUp){
                this.checkList.push('1')
            }
            if(OriginalDataDown===localDown){
                this.checkList.push('2')
            }
        },
        //g过滤男女大童勾选框
        FilterDataSelectBoyAndGirl(){
            let arr=this.DataList
            let OriginalBoyDown=0  //原数据 男下
            let OriginalBoyUp=0 //原数据 男上
            let OriginalGirlDown=0  //原数据 女下
            let OriginalGirlUp=0 //原数据 女上
            for(let i in arr){
                arr[i]['DOWN'].forEach(x=>{
                    if(x.typeId){
                        if(x.modelExtendCode==="BOY"){
                            OriginalBoyDown++
                        }else{
                            OriginalGirlDown++
                        }

                    }
                })
                arr[i]['UP'].forEach(y=>{
                    if(y.typeId){
                        if(y.typeId){
                            if(y.modelExtendCode==="GIRL"){
                                OriginalGirlUp++
                            }else{
                                OriginalBoyUp++
                            }

                        }
                    }
                })
            }
            let obj_a=0
            let obj_b=0
            let obj_c=0
            let obj_d=0
            this.SizeObj.forEach(val=>{
                if(val.typeMainCode==="DOWN"&&val.modelExtendCode==="BOY"){
                    obj_a++
                }else if(val.typeMainCode==="UP"&&val.modelExtendCode==="BOY"){
                    obj_b++
                }else if(val.typeMainCode==="DOWN"&&val.modelExtendCode==="GIRL"){
                    obj_c++
                }else{
                    obj_d++
                }
            })
            this.checkList=[]
            if(OriginalBoyDown===obj_a){
                this.checkList.push('3')
            }
            if(OriginalBoyUp===obj_b){
                this.checkList.push('1')
            }
            if(OriginalGirlDown===obj_c){
                this.checkList.push('4')
            }
            if(OriginalGirlUp===obj_d){
                this.checkList.push('2')
            }
        },
        //保存SelectTypeSize
        SetSelectTypeSize(name){
            if(name !=='BoysAndGirls'){
                this.FilterDataSelect()
            }else{
                this.FilterDataSelectBoyAndGirl()
            }

            let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
            let list={
                name:name,
                list:this.SizeObj,
                checkList:this.checkList
            }
            if(SelectTypeSize&&SelectTypeSize.Size){
                let Index=SelectTypeSize.Size.findIndex(item=>{
                    return item.name===name
                })
                if(Index<0){
                    SelectTypeSize.Size.push(list)
                }else{
                    SelectTypeSize.Size[Index]=list
                }
                localStorage.setItem(this.LocalKey,JSON.stringify(SelectTypeSize))
            }else{
                localStorage.setItem(this.LocalKey,JSON.stringify({
                    Size:[list]
                }))
            }
        },
    }
}
export  default SizeMixins